export class SaleOrderIdRequest {
    saleOrderId:number;
    plantId?:number;
    itemSubCategoryId?:number;
    state?:string;
    

    constructor(saleOrderId: number, plantId?: number,itemSubCategoryId?:number,state?:string) {
        this.saleOrderId = saleOrderId;
        this.plantId = plantId;
        this.itemSubCategoryId = itemSubCategoryId;
        this.state = state;
    }

}